import React, { ReactNode } from 'react';
import { Button as Btn, makeStyles, Box } from '@material-ui/core';
import classnames from 'classnames';

const styles = makeStyles(({ palette, spacing }: any) => ({
  textButton: {
    borderBottom: `1px solid ${palette.text.primary}`,
    paddingBottom: spacing(1),
    letterSpacing: '0.00938em',
    paddingRight: '0',
    paddingLeft: '0',
  },
  icon: {
    '& > svg': {
      fontSize: spacing(6),
    },
    marginRight: spacing(1),
  },
  label: {
    color: ({ labelColor }: any) => labelColor,
  },
}));

interface TextButtonProps {
  children: ReactNode;
  icon?: ReactNode;
  isDisabled?: boolean;
  className?: string;
  labelColor?: string;
  onClick?: () => void;
  variant?: 'text' | 'outlined' | 'contained';
}

const TextButton = ({
  children,
  icon,
  isDisabled = false,
  className,
  labelColor,
  onClick,
  variant = 'text',
  ...props
}: TextButtonProps) => {
  const classes = styles({ labelColor });

  const labelColorClass = classnames({
    [classes.label]: !!labelColor,
  });

  return (
    <Btn
      variant={variant}
      disableElevation
      disabled={isDisabled}
      className={`${className} ${classes.textButton}`}
      classes={{
        label: labelColorClass,
      }}
      onClick={onClick}
      {...props}
    >
      {icon && <Box className={classes.icon}>{icon}</Box>}
      {children}
    </Btn>
  );
};

export default TextButton;
